import Vue from 'vue';

export default {
  strict: false,
  state: () => ({
    users: {},
    history: {},
    private:{},
    notification: {
      aksi: [],
      informasi: []
    },
  }),
  getters: {
    GET_USERS: (state) => {
      return state.users;
    },
    GET_HISTORY: (state) => {
      return state.history;
    },
    GET_PRIVATE: (state) => {
      return state.private;
    }
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    ADD_USER(state, user) {
      Vue.set(state.users, user.id, user);
    },
    SET_HISTORY(state, history) {
      state.history = history;
    },
    ADD_MESSAGE(state, message) {
      Vue.set(state.history, message.id, message);
    },
    ADD_PRIVATE(state, msg) {
      state.private = msg;
    }
  },
  actions: {
    RECEIVE_USERS({ commit }, users,api) {
      commit('SET_USERS', users,api);
    },
    RECEIVE_USER({ commit }, user) {
      commit('ADD_USER', user);
    },
    RECEIVE_HISTORY({ commit }, history) {
      commit('SET_HISTORY', history);
    },
    RECEIVE_MESSAGE({ commit }, message) {
      commit('ADD_MESSAGE', message);
    },
    RECEIVE_PRIVATE({ commit }, message) {
      commit('ADD_PRIVATE', message);
    },
  }
};
